import React, { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Link, Outlet, useLocation, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import { colors } from '@styles/colors';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RestoreIcon from '@mui/icons-material/Restore';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BorderColorIcon from '@mui/icons-material/BorderColor';
// import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonIcon from '@mui/icons-material/Person';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import GroupsIcon from '@mui/icons-material/Groups';
import SignpostIcon from '@mui/icons-material/Signpost';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AdminMenuItem from '@components/AdminMenuItem';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AgendaMobileProgressFooter, { isAgendaBookingPath } from '@components/AgendaMobileProgressFooter';

import Citas from '@screens/citas/Citas';
import Ciudad from '@screens/agenda/Ciudad';
import Servicio from '@screens/agenda/Servicio';
import Agenda from '@screens/agenda/Agenda';
import Ubicacion from '@screens/agenda/Ubicacion';
import Modalidad from '@screens/agenda/Modalidad';
import Fechas from '@screens/agenda/Fechas';
import Medicos from '@screens/agenda/Medicos';
import Horas from '@screens/agenda/Horas';
import Confirmar from '@screens/agenda/confirmar';
import Final from '@screens/agenda/Final';

import { verUserApi, validateSsoApi } from "@api/wp/users/userApi";
import { viewUsuariosApi } from "@api/wp/usuarios/usuariosApi";
import Recibos from '@screens/recibos/Recibos';
import Resultados from '@screens/resultados/Resultados';
// Administracion 
import CitasExtras from '@screens/administracion/CitasExtras';
import Consultas from '@screens/administracion/Consultas';
import RPagos from '@screens/administracion/RPagos';
import Serviciosadmin from '@screens/administracion/ServiciosAdmin';
import Logs from '@screens/administracion/Logs';
import EmpresasZonas from '@screens/administracion/EmpresasZonas';
import SedesEspecialidades from '@screens/administracion/SedesEspecialidades';
import MedicosAdmin from '@screens/administracion/Medicos';
import EmpresasAdmin from '@screens/administracion/Empresas';
import SedesAdmin from '@screens/administracion/Sedes';
import MiembrosAdmin from '@screens/administracion/Miembros';
import Usuarios from '@screens/administracion/Usuarios';
import HomeAdmin from '@screens/administracion/Home';
import Roles from '@screens/administracion/Roles';
import NotFound from '@screens/NotFound';
import Login from '@screens/auth/Login';
import { useModo } from '@providers/modoContext';
import { CitaProvider, useCita } from '@providers/citaContext';
import {
  activateLocalSsoSession, clearLocalSsoSession,
  getLocalSsoExpiration, MEMBERSHIP_URL, MEMBERSHIP_PROFILE_URL, PREVIPLAN_HOME_URL
} from '@utils/const';
import { LAYOUT_COMPACT_MAX_PX } from '@utils/breakpoints';

function normalizePath(pathname = '/') {
  return (pathname || '/').replace(/\/$/, '') || '/';
}

function isAdminPath(pathname = '/') {
  const p = normalizePath(pathname);
  return (
    p === '/citasExtras'
    || p === '/empresas-zonas'
    || p === '/sedes-especialidades'
    || p.startsWith('/administracion/')
  );
}

// Componente de navegación con CSS personalizado
function Navigation() {
  const [userData, setUserData] = useState(null);
  const [membership_data, setmembership_data] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= LAYOUT_COMPACT_MAX_PX);
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [adminOpen, setAdminOpen] = useState(true);
  const [paramOpen, setParamOpen] = useState(false);
  const [consultasOpen, setConsultasOpen] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(window.innerWidth > LAYOUT_COMPACT_MAX_PX);
  const location = useLocation();
  const navigate = useNavigate();
  const { cita, setCita } = useCita();
  const { modo, setModo } = useModo();
  const [wpSessionClosed, setWpSessionClosed] = useState(false);
  const [nombreCompleto, setNombreCompleto] = useState('');
  const [sessionVersion, setSessionVersion] = useState(0);
  // Función para cerrar sesión
  const cerrarSesion = () => {
    // Limpiar todo el localStorage
    localStorage.clear();
    // Redirigir según modo: admin -> login, usuario -> membership
    if (modo === 1) {
      //window.location.href = '/login';
    } else {
      window.location.href = MEMBERSHIP_URL;
    }
  };

  useEffect(() => {
    const handleSessionUpdated = () => {
      setSessionVersion((currentValue) => currentValue + 1);
    };

    window.addEventListener('sso-session-updated', handleSessionUpdated);

    return () => {
      window.removeEventListener('sso-session-updated', handleSessionUpdated);
    };
  }, []);

  useEffect(() => {
    if (String(localStorage.getItem('modo')) !== '0') {
      return undefined;
    }

    const expiresAt = getLocalSsoExpiration();
    if (!expiresAt) {
      return undefined;
    }

    const remainingTime = expiresAt - Date.now();
    if (remainingTime <= 0) {
      clearLocalSsoSession();
      window.location.href = MEMBERSHIP_URL;
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      clearLocalSsoSession();
      window.location.href = MEMBERSHIP_URL;
    }, remainingTime);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.pathname, sessionVersion]);

  useEffect(() => {
    const cargarDatosUsuario = async () => {
      try {
        const userIdLocal = localStorage.getItem('idUsu');
        const userId = userIdLocal;
        if (!userId) {
          const tokenUrl = new URLSearchParams(location.search).get('t');
          if (tokenUrl) {
            setLoading(false);
            return;
          }
          setLoading(false);
          if (isAdminPath(location.pathname)) {
            navigate('/login', { replace: true });
          } else {
            window.location.replace(MEMBERSHIP_PROFILE_URL);
          }
          return;
        }
        const data = {
          "id": userId
        };
        const response = await verUserApi(data)
        console.log('RES ', response)
        // Validar sesión de WordPress solo en modo usuario (modo === 0)
        if (modo === 0 && response?.result?.logeo === 0) {
          setWpSessionClosed(true);
          cerrarSesion();
          return; // Evitar continuar con procesamiento local si no hay sesión
        }
        //setUserData(response.result.dataUser);
        setUserData(response.result);
        setmembership_data(response.result.membership_data);
        // Procesar y guardar datos del usuario en localStorage

        // Guardar en localStorage
        localStorage.setItem('idUsu', userId);
        localStorage.setItem('cedula', response.result.id_number);
        localStorage.setItem('nombreCompleto', response.result.first_name + ' ' + response.result.second_name);
        localStorage.setItem('levelMem', response.result?.membership_data[0].membership_id);
        setNombreCompleto(response.result.first_name)
        //          console.log('Datos del usuario guardados en localStorage:', userData);

      } catch (error) {
        console.error('Error al consultar la API:', error);
      } finally {
        setLoading(false);
      }
    };

    // En modo admin (modo = 1), consultar el registro del usuario logueado
    const cargarDatosAdmin = async () => {
      try {
        const idUsu = localStorage.getItem('idUsu');
        if (!idUsu) {
          console.warn('No se encontró idUsu en localStorage');
          setLoading(false);
          return;
        }
        const resp = await viewUsuariosApi({ id: Number(idUsu) });
        const lista = resp?.result || resp || [];
        const usuario = Array.isArray(lista) ? lista[0] : lista;
        console.log('Usuario logueado (admin):', usuario);

        // Guardar en localStorage
        //        localStorage.setItem('cedula', response.result.cedula);
        localStorage.setItem('nombreCompleto', usuario.alias);
        setNombreCompleto(usuario.alias)

      } catch (error) {
        console.error('Error consultando usuario logueado (admin):', error);
      } finally {
        setLoading(false);
      }
    };

    const handleResize = () => {
      const mobile = window.innerWidth <= LAYOUT_COMPACT_MAX_PX;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarVisible(true);
      } else {
        setIsSidebarVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    // Ejecutar carga de datos solo si modo en localStorage es 0 o no existe
    const modoLocal = localStorage.getItem('modo');
    if (modoLocal === null || String(modoLocal) === '0') {
      cargarDatosUsuario();
    } else {
      // Si estamos en modo admin (1), consultar endpoint de usuarios por idUsu y mostrar en consola
      cargarDatosAdmin();
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname, location.search, navigate, sessionVersion]);

  useEffect(() => {
    if (isMobile) {
      setIsSidebarVisible(false);
    }
  }, [location.pathname, isMobile]);

  // Interceptar F5 / Ctrl+R / Cmd+R cuando hay datos en el contexto de cita
  useEffect(() => {
    const handleReloadKey = (e) => {
      const isF5 = e.key === 'F5' || e.keyCode === 116; // F5
      const isReloadCombo = ((e.key === 'r' || e.keyCode === 82) && (e.ctrlKey || e.metaKey)); // Ctrl+R / Cmd+R
      if (!isF5 && !isReloadCombo) return;
      const tieneDatosCita = cita && Object.keys(cita || {}).length > 0;
      if (tieneDatosCita) {
        e.preventDefault();
        e.stopPropagation();
        const confirma = window.confirm('Si recargas (F5) perderás los datos de tu cita. ¿Quieres volver a seleccionar ciudad?');
        if (confirma) {
          try { setCita({}); } catch { }
          navigate('/home', { replace: true });
        }
      }
    };

    window.addEventListener('keydown', handleReloadKey, true);
    return () => {
      window.removeEventListener('keydown', handleReloadKey, true);
    };
  }, [cita, navigate, setCita]);

  const [showPageScrollHint, setShowPageScrollHint] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      setShowPageScrollHint(false);
      return undefined;
    }

    const measure = () => {
      const root = document.documentElement;
      const scrollBottom = window.scrollY + window.innerHeight;
      const total = root.scrollHeight;
      const threshold = 32;
      const hasOverflow = total > window.innerHeight + threshold;
      const notAtBottom = scrollBottom < total - threshold;
      setShowPageScrollHint(hasOverflow && notAtBottom);
    };

    measure();
    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (ro) {
      ro.observe(document.body);
    }

    return () => {
      window.removeEventListener('scroll', measure);
      window.removeEventListener('resize', measure);
      if (ro) {
        ro.disconnect();
      }
    };
  }, [isMobile, location.pathname]);

  // En escritorio el lateral empuja el contenido; en móvil/tablet queda flotante (overlay) sin reducir el área útil.
  const sidebarOffsetsLayout = !isMobile && isSidebarVisible;
  const agendaBookingCompact = isMobile && isAgendaBookingPath(location.pathname);
  const mobileContentPaddingBottom = isMobile
    ? (agendaBookingCompact
      ? 'calc(5.75rem + env(safe-area-inset-bottom, 0px))'
      : '9vh')
    : undefined;
  const scrollHintBottom = agendaBookingCompact
    ? 'calc(5.75rem + env(safe-area-inset-bottom, 0px) + 10px)'
    : 'calc(9vh + 10px)';

  return (
    <div style={{ display: 'flex', minHeight: '100vh', width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
      {isMobile && isSidebarVisible && (
        <div
          role="presentation"
          onClick={() => setIsSidebarVisible(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 999,
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
          }}
        />
      )}
      {/* Menú Galletica (Hamburger) */}
      <div
        onClick={() => setIsSidebarVisible(!isSidebarVisible)}
        style={{
          position: 'fixed',
          top: '3vh',
          left: '3vh',
          zIndex: 1100,
          cursor: 'pointer',
          backgroundColor: colors.white,
          padding: '1vh', // increased padding
          borderRadius: '0.8vh',
          boxShadow: '0 0.2vh 0.6vh rgba(0,0,0,0.3)',
          display: isMobile ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <MenuIcon style={{ width: '4.5vh', height: '4.5vh', color: colors.gray700 }} /> {/* increased size */}
      </div>

      {/* Caja pegada a la izquierda */}
      <div id="divCajaIzquierda" style={{
        display: isSidebarVisible ? 'block' : 'none',
        width: '37.2vh', // 372px
        height: '100vh',
        backgroundColor: colors.white,
        position: 'fixed',
        left: '0',
        top: '0',
        zIndex: 1000,
        borderRight: `0.1vh solid ${colors.borderSidebar}`,
        boxShadow: isMobile && isSidebarVisible ? '0.4vh 0 2.4vh rgba(0,0,0,0.18)' : 'none',
      }}>
        {/* Logo (en móvil más pequeño y centrado debajo del área de la galleta fija) */}
        <img
          src="/Logo.svg"
          alt="Logo"
          style={{
            width: isMobile ? '16vh' : '24.0vh',
            height: isMobile ? '5.2vh' : '7.96vh',
            position: 'absolute',
            top: isMobile ? '10.4vh' : '3.4vh',
            left: isMobile ? '50%' : '16.4%',
            transform: isMobile ? 'translateX(-50%)' : 'rotate(0deg)',
            opacity: 1,
            objectFit: 'contain',
          }}
        />

        {/* Div cajaUsuario */}
        <div id="cajaUsuario" style={{
          width: '28.3vh',
          height: '7.3vh',
          position: 'absolute',
          angle: '0 deg',
          top: '15.7vh', // 169px - usando vh para responsividad
          left: '4.4vh', // 96px
          transform: 'rotate(0deg)',
          opacity: 1,
          borderRadius: '1vh',
          backgroundColor: colors.resumenBg
        }}>
          {/* Div interno dentro de cajaUsuario */}
          <div id="cajaAvatar" style={{
            width: '24.9vh',
            height: '4.3vh',
            position: 'absolute',
            top: '0.5vh', // Posicionado dentro de cajaUsuario
            left: '1.7vh', // Centrado horizontalmente dentro de cajaUsuario
            transform: 'rotate(0deg)',
            opacity: 1,
            backgroundColor: colors.resumenBg
          }}>
            {/* Div cajaImgAvatar */}
            <div id="cajaImgAvatar" style={{
              width: '4.3vh', // 43px
              height: '4.3vh', // 43px
              position: 'absolute',
              top: '0.8vh',
              left: '0',
              transform: 'rotate(0deg)',
              opacity: 1,
              borderRadius: '3vh',
              backgroundColor: colors.gray50
            }}>
              <img
                src="/avatar.png"
                alt="Avatar"
                style={{
                  width: '4.3vh',
                  height: '4.3vh',
                  top: '0vh',
                  left: '0',
                  position: 'absolute',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  objectFit: 'cover'
                }}
              />
              {/* Contenido del cajaImgAvatar */}
            </div>

            {/* Div contenedor del label nombreCompleto */}
            <div style={{
              position: 'absolute',
              top: '2.2vh',
              left: '6vh',
              width: '70%',
              height: '4.3vh',
              display: 'flex',
              alignItems: 'flex-start'
            }}>
              <label id="labelAvatar" style={{
                fontFamily: 'Inter',
                fontSize: '1.9vh',
                fontWeight: 500,
                color: colors.primaryText,
              }}>{nombreCompleto}</label>
            </div>
          </div>

          {/* Caja Editar Usuario */}
          <div id="cajaEditarUsuario"
            onClick={() => window.open(MEMBERSHIP_PROFILE_URL, '_blank', 'noopener,noreferrer')}
            style={{
              width: '1.9vh', // 18.75
              height: '1.9vh',
              position: 'absolute',
              top: '2.6vh',
              left: '24vh',
              transform: 'rotate(0deg)',
              opacity: 1,
              backgroundColor: colors.resumenBg,
              cursor: 'pointer'
            }}>
            <BorderColorIcon style={{
              width: '100%',
              height: '100%'
            }} />
            {/* Fi Caja Editar Usuario */}
          </div>
        </div>

        {/* Menú de navegación vertical */}
        <nav id="navCaja" style={{
          position: 'absolute',
          top: '32vh', // 320px - usando vh para responsividad
          left: '11.83%', // 44px
          width: '76.16%', // 283.33px
          display: modo === 1 ? 'none' : 'flex',
          flexDirection: 'column',
          gap: '10px'
        }}>
          <Link
            to="/home"
            onClick={() => setActiveMenuItem('home')}
            style={{
              textDecoration: 'none',
              color: colors.gray700,
              fontFamily: 'Inter',
              fontSize: '1.9vh',
              fontWeight: activeMenuItem === 'home' ? '700' : '500',
              padding: '1.0vh 1.5vh',
              backgroundColor: activeMenuItem === 'home' ? colors.primary : colors.gray200,
              borderRadius: '1vh',
              border: '0.1vh solid transparent',
              transition: 'all 0.2s ease',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            onMouseEnter={(e) => {
              if (activeMenuItem !== 'home') {
                e.currentTarget.style.backgroundColor = colors.primary;
                e.currentTarget.style.color = colors.gray700;
              }
            }}
            onMouseLeave={(e) => {
              if (activeMenuItem !== 'home') {
                e.currentTarget.style.backgroundColor = colors.gray200;
                e.currentTarget.style.color = colors.gray700;
              }
            }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.8vh' }}>
              <CalendarMonthIcon style={{ width: '2.6vh', height: '2.6vh' }} />
              Solicitar citas
            </span>
            {activeMenuItem === 'home' ? <ExpandMoreIcon /> : <ChevronRightIcon />}
          </Link>
          <Link
            to="/citas"
            onClick={() => setActiveMenuItem('citas')}
            style={{
              textDecoration: 'none',
              color: colors.gray700,
              fontFamily: 'Inter',
              fontSize: '1.9vh',
              fontWeight: activeMenuItem === 'citas' ? '700' : '500',
              padding: '1.0vh 1.5vh',
              backgroundColor: activeMenuItem === 'citas' ? colors.primary : colors.gray200,
              borderRadius: '1vh',
              border: '0.1vh solid transparent',
              transition: 'all 0.2s ease',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            onMouseEnter={(e) => {
              if (activeMenuItem !== 'citas') {
                e.currentTarget.style.backgroundColor = colors.primary;
                e.currentTarget.style.color = colors.gray700;
              }
            }}
            onMouseLeave={(e) => {
              if (activeMenuItem !== 'citas') {
                e.currentTarget.style.backgroundColor = colors.gray200;
                e.currentTarget.style.color = colors.gray700;
              }
            }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.8vh' }}>
              <RestoreIcon style={{ width: '2.6vh', height: '2.6vh' }} />
              Historial de citas
            </span>
            {activeMenuItem === 'citas' ? <ExpandMoreIcon /> : <ChevronRightIcon />}
          </Link>
          <Link
            to="/recibos"
            onClick={() => setActiveMenuItem('recibos')}
            style={{
              textDecoration: 'none',
              color: colors.gray700,
              fontFamily: 'Inter',
              fontSize: '1.9vh',
              fontWeight: activeMenuItem === 'recibos' ? '700' : '500',
              padding: '1.0vh 1.5vh',
              backgroundColor: activeMenuItem === 'recibos' ? colors.primary : colors.gray200,
              borderRadius: '1vh',
              border: '0.1vh solid transparent',
              transition: 'all 0.2s ease',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            onMouseEnter={(e) => {
              if (activeMenuItem !== 'recibos') {
                e.currentTarget.style.backgroundColor = colors.primary;
                e.currentTarget.style.color = colors.gray700;
              }
            }}
            onMouseLeave={(e) => {
              if (activeMenuItem !== 'recibos') {
                e.currentTarget.style.backgroundColor = colors.gray200;
                e.currentTarget.style.color = colors.gray700;
              }
            }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.8vh' }}>
              <PriceCheckIcon style={{ width: '2.6vh', height: '2.6vh' }} />
              Recibo de pago
            </span>
            {activeMenuItem === 'recibos' ? <ExpandMoreIcon /> : <ChevronRightIcon />}
          </Link>
        </nav>
        {modo === 1 && (
          <nav id="navCaja" style={{
            position: 'absolute',
            top: '32vh',
            left: '11.83%',
            width: '76.16%',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <div id="opcionAdmin"
              onClick={() => { setAdminOpen(!adminOpen); setParamOpen(false); setConsultasOpen(false); }}
              style={{
                textDecoration: 'none',
                color: colors.gray700,
                fontFamily: 'Inter',
                fontSize: '1.9vh',
                padding: '1.0vh 1.5vh',
                backgroundColor: adminOpen ? colors.primary : colors.gray200,
                borderRadius: '1.2vh',
                border: '0.1vh solid transparent',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <CheckCircleOutlineIcon style={{ width: '2.6vh', height: '2.6vh' }} />
              <span>Administración</span>
              {adminOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.8vh',
              alignItems: 'flex-start',
              boxSizing: 'border-box',
              width: '100%',
              paddingLeft: '2vh',
              maxHeight: adminOpen ? '50vh' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.7s ease-out, opacity 0.7s ease-out',
              opacity: adminOpen ? 1 : 0,
            }}>
              {(localStorage.getItem('idRol') === '1' || localStorage.getItem('idRol') === '2') && (
                <>
                  <AdminMenuItem
                    to="/citasExtras"
                    radius="1vh"
                    icon={<CalendarMonthIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Programación
                  </AdminMenuItem>
                </>
              )}
              {(localStorage.getItem('idRol') === '1' || localStorage.getItem('idRol') === '3') && (
                <>
                  <AdminMenuItem
                    to="/administracion/medicos"
                    radius="1vh"
                    icon={<PersonIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Médicos
                  </AdminMenuItem>
                </>
              )}
              {(localStorage.getItem('idRol') === '1') && (
                <>
                  <AdminMenuItem
                    to="/administracion/servicios"
                    icon={<MonetizationOnIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Precios de servicios
                  </AdminMenuItem>
                  <AdminMenuItem
                    to="/administracion/sedes"
                    icon={<FmdGoodIcon style={{ width: '2.6vh', height: '2.6vh', color: colors.gray700 }} />}
                  >
                    Sedes
                  </AdminMenuItem>
                  <AdminMenuItem
                    to="/administracion/miembros"
                    icon={<GroupsIcon style={{ width: '2.6vh', height: '2.6vh', color: colors.gray700 }} />}
                  >
                    Miembros
                  </AdminMenuItem>
                </>
              )}
            </div>

            <div id="opcionConsultas"
              onClick={() => { setConsultasOpen(!consultasOpen); setAdminOpen(false); setParamOpen(false); }}
              style={{
                textDecoration: 'none',
                color: colors.gray700,
                fontFamily: 'Inter',
                fontSize: '1.9vh',
                padding: '1.0vh 1.5vh',
                backgroundColor: consultasOpen ? colors.primary : colors.gray200,
                borderRadius: '1.2vh',
                border: '0.1vh solid transparent',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <ManageSearchIcon style={{ width: '2.6vh', height: '2.6vh' }} />
              <span>Consultas</span>
              {consultasOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.8vh',
              alignItems: 'flex-start',
              boxSizing: 'border-box',
              width: '100%',
              paddingLeft: '2vh',
              maxHeight: consultasOpen ? '50vh' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.7s ease-out, opacity 0.7s ease-out',
              opacity: consultasOpen ? 1 : 0,
            }}>
              {(localStorage.getItem('idRol') === '1' || localStorage.getItem('idRol') === '2') && (
                <>
                  <AdminMenuItem
                    to="/administracion/consultas"
                    radius="1vh"
                    icon={<ManageSearchIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Agendamientos
                  </AdminMenuItem>
                  <AdminMenuItem
                    to="/administracion/rpagos"
                    radius="1vh"
                    icon={<PriceCheckIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Pagos
                  </AdminMenuItem>
                  <AdminMenuItem
                    to="/administracion/logs"
                    radius="1vh"
                    icon={<ManageSearchIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Logs
                  </AdminMenuItem>
                </>
              )}
            </div>

            {localStorage.getItem('idRol') === '1' && (
              <>
                <div
                  onClick={() => { setParamOpen(!paramOpen); setAdminOpen(false); setConsultasOpen(false); }}
                  style={{
                    textDecoration: 'none',
                    color: colors.gray700,
                    fontFamily: 'Inter',
                    fontSize: '1.9vh',
                    padding: '1.0vh 1.5vh',
                    backgroundColor: paramOpen ? colors.primary : colors.gray200,
                    borderRadius: '1.2vh',
                    border: '0.1vh solid transparent',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <MiscellaneousServicesIcon style={{ width: '2.6vh', height: '2.6vh' }} />
                  <span>Parametrización</span>
                  {paramOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.8vh',
                  alignItems: 'flex-start',
                  boxSizing: 'border-box',
                  width: '100%',
                  paddingLeft: '2vh',
                  maxHeight: paramOpen ? '50vh' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.7s ease-out, opacity 0.7s ease-out',
                  opacity: paramOpen ? 1 : 0,
                }}>
                  <AdminMenuItem
                    to="/administracion/usuarios"
                    icon={<ManageAccountsIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Usuarios
                  </AdminMenuItem>
                  <AdminMenuItem
                    to="/administracion/empresas"
                    icon={<LocationCityIcon style={{ width: '2.6vh', height: '2.6vh' }} />}
                  >
                    Pasarela de pagos
                  </AdminMenuItem>
                  <AdminMenuItem
                    to="/empresas-zonas"
                    icon={<SignpostIcon style={{ width: '2.6vh', height: '2.6vh', color: colors.gray700 }} />}
                  >
                    Zonas
                  </AdminMenuItem>
                </div>
              </>
            )}
          </nav>
        )}
        {/* Nuevo div responsive */}
        {modo !== 1 && (
          <div id="cajaMembre" style={{
            width: '28.3vh', // 255px
            minHeight: '11.5vh', // 115px
            height: 'auto',
            position: 'absolute',
            top: '70vh', // 693px
            left: '4.4vh', // 56px
            opacity: 1,
            borderRadius: '1vh',
            backgroundColor: colors.resumenBg,
            display: 'flex',
            alignItems: 'center',
            padding: '1.5vh',
            gap: '1.5vh',
            boxSizing: 'border-box'
          }}>
            <img
              src={'/card.png'}
              alt={'Membresía'}
              style={{
                width: '5.397vh',
                height: '5.314vh',
                objectFit: 'contain'
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5vh', flex: 1 }}>
              <label id="labelMebre" style={{
                fontFamily: 'Inter',
                fontWeight: 800,
                fontStyle: 'normal',
                fontSize: '1.8vh',
                lineHeight: '100%',
                color: colors.primaryText,
              }}>
                Membresia
              </label>

              <label id="labelMebre" style={{
                fontFamily: 'Inter',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '1.3vh',
                lineHeight: '120%',
              }}>
                {membership_data?.[0]?.membership_name || ''}
              </label>

              {(() => {
                const rawEnd = membership_data?.[0]?.membership_end_date;
                const endYmd = rawEnd != null ? String(rawEnd).trim().slice(0, 10) : '';
                if (!endYmd || endYmd === '0000-00-00') return null;
                return (
                  <label id="labelMebre" style={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontStyle: 'normal',
                    fontSize: '1.3vh',
                    lineHeight: '100%',
                  }}>
                    Vencimiento: {rawEnd}
                  </label>
                );
              })()}

              <label id="labelMebre" style={{
                fontFamily: 'Inter',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '1.3vh',
                lineHeight: '100%',
              }}>
                Estado: {(membership_data?.[0]?.status === 'active' ? 'Activa' : membership_data?.[0]?.status) || ''}
              </label>
            </div>
          </div>
        )}

        {/* Nuevo div con imagen salir.png */}
        <div
          onClick={cerrarSesion}
          style={{
            width: '28.3vh',
            height: '4.9vh',
            position: 'absolute',
            top: '85.2vh',
            left: '4.4vh', // 56px            
            transform: 'rotate(0deg)',
            opacity: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: colors.gray300,
            gap: '1vh',
            borderRadius: '1vh',
            cursor: 'pointer'
          }}>
          <LogoutIcon style={{ width: '2.00vh', height: '2.00vh' }} />
          <label style={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: '1.5vh',
            lineHeight: '100%',
            letterSpacing: '0%',
            color: colors.gray700,
            cursor: 'pointer'
          }}>
            Cerrar sesión
          </label>
        </div>

        {/* Contenido de la caja lateral */}
      </div>

      {/* Footer: en móvil/tablet durante el agendamiento, barra de pasos + resumen; si no, texto legal fijo */}
      {agendaBookingCompact ? (
        <AgendaMobileProgressFooter />
      ) : (
        <div id="divCajaFooter" style={{
          width: sidebarOffsetsLayout ? 'calc(100% - 37.2vh)' : '100%',
          height: '9.0vh',
          backgroundColor: colors.gray150,
          position: 'fixed',
          bottom: '0',
          left: sidebarOffsetsLayout ? '37.2vh' : '0',
          opacity: 1,
          transform: 'rotate(0deg)',
          zIndex: 999,
          transition: 'all 0.3s ease'
        }}>
          <div style={{
            width: '46.5vh',
            height: '2.0vh',
            position: 'absolute',
            top: '3vh',
            left: '6.5vh',
            transform: 'rotate(0deg)',
            opacity: 1
          }}>
            <span style={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '1.9vh',
              lineHeight: '2.0vh',
              letterSpacing: '0%',
              color: colors.gray700
            }}>
              Derechos reservados Copyright © {new Date().getFullYear()}
            </span>
          </div>
        </div>
      )}

      {/* Área de contenido principal: 100% del padre menos sidebar (evita 192vh y el overflow de 100vw con barra de scroll) */}
      <div style={{
        marginLeft: sidebarOffsetsLayout ? '37.2vh' : '0',
        width: sidebarOffsetsLayout ? 'calc(100% - 37.2vh)' : '100%',
        maxWidth: sidebarOffsetsLayout ? 'calc(100% - 37.2vh)' : '100%',
        minWidth: 0,
        minHeight: '100vh',
        paddingTop: '3vh',
        paddingBottom: mobileContentPaddingBottom,
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
      }}>
        {wpSessionClosed && (
          <div style={{
            margin: '0 2vh 2vh',
            padding: '1.2vh 1.6vh',
            background: colors.alertWpBg,
            border: `0.2vh solid ${colors.alertWpBorder}`,
            color: colors.alertWpText,
            borderRadius: '1vh',
            fontFamily: 'Inter',
            fontSize: '1.8vh'
          }}>
            La sesión en WordPress ha sido cerrada. Por favor inicia sesión nuevamente.
          </div>
        )}
        <Outlet />
      </div>

      {isMobile && showPageScrollHint && !isSidebarVisible && (
        <div
          aria-hidden
          style={{
            position: 'fixed',
            left: '50%',
            bottom: scrollHintBottom,
            zIndex: 1005,
            pointerEvents: 'none',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div className="scroll-hint-more-below__arrow">
            <KeyboardArrowDownIcon style={{ fontSize: '2.25rem', color: colors.gray700 }} />
          </div>
        </div>
      )}
    </div>
  );
}

// Componente de página principal simplificado
function MainPage() {
  return (
    <div style={{ minHeight: '60vh' }}>
      {/* Área en blanco como solicitaste */}
    </div>
  );
}

function SsoLogin() {
  const navigate = useNavigate();
  const [mensaje, setMensaje] = useState('Validando acceso...');

  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams(window.location.search);
    const token = params.get('t') || '';

    const validarSso = async () => {
      if (!token) {
        setMensaje('No se encontró el token SSO.');
        return;
      }
      try {
        const response = await validateSsoApi({ t: token });
        console.log('REQ ', response)
        const result = response?.result || response;
        console.log('RES ', response)
        if (cancelled) {
          return;
        }
        if (result?.success === true) {
          const userId = String(result?.user_id || '');
          if (userId) {
            activateLocalSsoSession(userId, token);
          }
          navigate('/home', { replace: true });
          return;
        }
        setMensaje(result?.message || 'Token inválido o expirado.');
      } catch (error) {
        if (cancelled) {
          return;
        }
        setMensaje('No fue posible validar el acceso SSO.');
      }
    };
    validarSso();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.gray50,
      fontFamily: 'Inter',
      color: colors.primaryText,
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: colors.white,
        borderRadius: '16px',
        padding: '32px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
        maxWidth: '460px',
        width: '100%'
      }}>
        <div style={{ fontSize: '24px', fontWeight: 700, marginBottom: '12px' }}>
          Validando acceso Autoagendamiento
        </div>
        <div style={{ fontSize: '16px', lineHeight: 1.5 }}>
          {mensaje}
        </div>
      </div>
    </div>
  );
}

// Índice de la raíz: si no existe sesión local, redirige a previplan.co
function RootIndex() {
  const userId = localStorage.getItem('idUsu');
  if (!userId) {
    window.location.href = PREVIPLAN_HOME_URL;
    return null;
  }
  return <MainPage />;
}

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/sso-login",
    element: <SsoLogin />,
  },
  {
    path: "/",
    element: <Navigation />,
    children: [
      {
        index: true,
        element: <RootIndex />,
      },
      {
        path: "home",
        element: <Ciudad />,
      },
      {
        path: "servicios",
        element: <Servicio />,
      },
      {
        path: "citas",
        element: <Citas />,
      },
      {
        path: "resultados",
        element: <Resultados />,
      },
      {
        path: "recibos",
        element: <Recibos />,
      },
      {
        path: "ubicacion",
        element: <Ubicacion />,
      },
      {
        path: "modalidad",
        element: <Modalidad />,
      },
      {
        path: "fechas",
        element: <Fechas />,
      },
      {
        path: "agenda/medicos",
        element: <Medicos />,
      },
      {
        path: "agenda/horas",
        element: <Horas />,
      },
      {
        path: "confirmar",
        element: <Confirmar />,
      },
      {
        path: "final",
        element: <Final />,
      },
      {
        path: "citasExtras",
        element: <CitasExtras />,
      },
      {
        path: "administracion/home",
        element: <HomeAdmin />,
      },
      {
        path: "administracion/consultas",
        element: <Consultas />,
      },
      {
        path: "administracion/rpagos",
        element: <RPagos />,
      },
      {
        path: "administracion/logs",
        element: <Logs />,
      },
      {
        path: "administracion/citasExtras",
        element: <CitasExtras />,
      },
      {
        path: "administracion/servicios",
        element: <Serviciosadmin />,
      },
      {
        path: "empresas-zonas",
        element: <EmpresasZonas />,
      },
      {
        path: "sedes-especialidades",
        element: <SedesEspecialidades />,
      },
      {
        path: "administracion/medicos",
        element: <MedicosAdmin />,
      },
      {
        path: "administracion/empresas",
        element: <EmpresasAdmin />,
      },
      {
        path: "administracion/sedes",
        element: <SedesAdmin />,
      },
      {
        path: "administracion/miembros",
        element: <MiembrosAdmin />,
      },
      {
        path: "administracion/usuarios",
        element: <Usuarios />,
      },
      {
        path: "administracion/roles",
        element: <Roles />,
      },

    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

function App() {
  console.log('App component rendered');

  const pathname = normalizePath(window.location.pathname);
  const hasUserSession = Boolean(localStorage.getItem('idUsu'));
  const isPublicPath = pathname === '/login' || pathname === '/sso-login';

  if (!hasUserSession && !isPublicPath) {
    if (isAdminPath(pathname)) {
      window.location.replace('/login');
      return null;
    }
    window.location.replace(MEMBERSHIP_PROFILE_URL);
    return null;
  }

  return (
    <CitaProvider>
      <RouterProvider router={router} />
    </CitaProvider>
  );
}

export default App;
